import { defineMessages } from "react-intl";

const PREFIX = "BulkExportPage.TransferList";
export const messages = defineMessages({
  searchPlaceholder: {
    id: `${PREFIX}.searchPlaceholder`,
    defaultMessage: "Quick search...",
  },
});
